var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutFaqHelpQuestionSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.99,
    height: 24.903,
    viewBox: "0 0 24.99 24.903",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "about-faq-help-question-svgrepo-com",
    transform: "translate(-95.748 -577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23327",
    "data-name": "Path 23327",
    d: "M110.21,589.725a1.758,1.758,0,0,1,.361-1.059,6.861,6.861,0,0,1,1.066-1.095,7.489,7.489,0,0,0,.976-1.013,1.466,1.466,0,0,0,.272-.886,1.445,1.445,0,0,0-1.465-1.477,1.531,1.531,0,0,0-1.048.4,2.64,2.64,0,0,0-.7,1.168l-1.589-.694a3.714,3.714,0,0,1,1.273-1.962,3.416,3.416,0,0,1,2.142-.685,3.67,3.67,0,0,1,1.689.392,3.079,3.079,0,0,1,1.219,1.1,2.935,2.935,0,0,1,.452,1.606,2.724,2.724,0,0,1-.4,1.451,6.5,6.5,0,0,1-1.211,1.378,10.23,10.23,0,0,0-1,.976,1.134,1.134,0,0,0-.28.739,2.1,2.1,0,0,0,.074.493h-1.625A2.022,2.022,0,0,1,110.21,589.725Zm1.084,5.147a1.367,1.367,0,0,1-1-.4,1.353,1.353,0,0,1-.407-1,1.385,1.385,0,0,1,.407-1.013,1.355,1.355,0,0,1,1-.411,1.381,1.381,0,0,1,1.41,1.424,1.355,1.355,0,0,1-.406,1,1.372,1.372,0,0,1-1,.4Z",
    transform: "translate(-3.223 -1.417)",
    fill: "#642d92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23328",
    "data-name": "Path 23328",
    d: "M96.837,601.9a1.089,1.089,0,0,1-.462-.1,1.078,1.078,0,0,1-.626-.985V579.638A2.641,2.641,0,0,1,98.386,577H118.1a2.641,2.641,0,0,1,2.638,2.638v15.079a2.641,2.641,0,0,1-2.638,2.637H103.348a1.887,1.887,0,0,0-1.209.439l-4.609,3.855A1.083,1.083,0,0,1,96.837,601.9Zm1.55-23.426a1.163,1.163,0,0,0-1.161,1.161v20.339l3.966-3.317a3.368,3.368,0,0,1,2.157-.783H118.1a1.162,1.162,0,0,0,1.161-1.16V579.638a1.163,1.163,0,0,0-1.161-1.161Z",
    fill: "#642d92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutFaqHelpQuestionSvgrepoCom);
export default __webpack_public_path__ + "static/media/about-faq-help-question-svgrepo-com.09f53145c0777577fcbe5167ad070903.svg";
export { ForwardRef as ReactComponent };